import { Component } from '@angular/core';

@Component({
  selector: 'app-flow-tools-page',
  templateUrl: './flow-tools-page.component.html',
  styleUrls: ['./flow-tools-page.component.scss'],
})
export class FlowToolsPageComponent {}
